(() => {
  const initializeHeaderSearch = (root = document) => {
    const panels = root.querySelectorAll('[data-header-search-panel]');

    panels.forEach((panel) => {
      if (panel.dataset.initialized === 'true') return;

      const sectionId = panel.dataset.headerSearchPanel;
      const wrapper = panel.closest('.header-wrapper');
      const section = panel.closest('.section-header') || document;
      const triggers = section.querySelectorAll(
        `[data-header-search-open="${CSS.escape(sectionId)}"]`
      );
      const closeButton = panel.querySelector(
        `[data-header-search-close="${CSS.escape(sectionId)}"]`
      );
      const input = panel.querySelector('.header-search-replacement__input');

      if (!wrapper || triggers.length === 0 || !closeButton || !input) return;

      panel.dataset.initialized = 'true';
      let lastTrigger = null;

      const setExpanded = (expanded) => {
        triggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      };

      const open = (trigger) => {
        lastTrigger = trigger || triggers[0];

        wrapper.querySelectorAll('.header details[open]').forEach((details) => {
          details.removeAttribute('open');
        });

        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        wrapper.classList.add('is-search-open');
        setExpanded(true);

        window.requestAnimationFrame(() => {
          input.focus({ preventScroll: true });
        });
      };

      const close = ({ restoreFocus = true } = {}) => {
        wrapper.classList.remove('is-search-open');
        panel.setAttribute('aria-hidden', 'true');
        setExpanded(false);
        panel.hidden = true;

        if (restoreFocus && lastTrigger) {
          lastTrigger.focus({ preventScroll: true });
        }
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => open(trigger));
      });

      closeButton.addEventListener('click', () => close());

      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeaderSearch());
  } else {
    initializeHeaderSearch();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeHeaderSearch(event.target);
  });
})();
